import { render, staticRenderFns } from "./TqDropdown.vue?vue&type=template&id=392fd72c&scoped=true&"
import script from "./TqDropdown.vue?vue&type=script&lang=js&"
export * from "./TqDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TqDropdown.vue?vue&type=style&index=0&id=392fd72c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392fd72c",
  null
  
)

export default component.exports